(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offre-speciale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPcOffre() {
      document.querySelectorAll('.pc-offre').forEach(function (root) {
        if (root.dataset.pcFaqBound) return;
        root.dataset.pcFaqBound = '1';
        root.querySelectorAll('.pc-faq details').forEach(function (item) {
          item.addEventListener('toggle', function () {
            if (!item.open) return;
            root.querySelectorAll('.pc-faq details[open]').forEach(function (other) {
              if (other !== item) other.removeAttribute('open');
            });
          });
        });
      });
    }
    initPcOffre();
    document.addEventListener('shopify:section:load', initPcOffre);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-avis-etoile-grille"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zs-avis-grille')) {
  class ZsAvisGrille extends HTMLElement {
    connectedCallback() {
      this.grille = this.querySelector('[data-grille]');
      this.dlg = this.querySelector('.zsag-dlg--avis');
      this.dlgForm = this.querySelector('.zsag-dlg--form');
      this.bindDialogs();
      if (!this.grille) return;
      this.cards = Array.from(this.grille.querySelectorAll('.zsag-card'));
      this.holder = document.createElement('div');
      this.holder.className = 'zsag-holder';
      this.state = { tri: this.dataset.tri || 'photos', photos: false, etoile: 0, vus: this.pas() };
      this.mq = window.matchMedia('(min-width: 750px)');
      this.bind();
      this.render();
      this._onResize = () => {
        clearTimeout(this._t);
        this._t = setTimeout(() => { if (this.cols() !== this._cols) this.render(); }, 150);
      };
      window.addEventListener('resize', this._onResize);
      this.cards.forEach((c) => {
        const img = c.querySelector('.zsag-card__media img');
        if (img && !img.complete) img.addEventListener('load', () => { clearTimeout(this._t2); this._t2 = setTimeout(() => this.render(true), 120); }, { once: true });
      });
    }
    disconnectedCallback() { window.removeEventListener('resize', this._onResize); }
    pas() {
      const d = parseInt(this.dataset.initD, 10) || 12;
      const m = parseInt(this.dataset.initM, 10) || 6;
      return window.matchMedia('(min-width: 750px)').matches ? d : m;
    }
    cols() {
      const v = getComputedStyle(this).getPropertyValue(this.mq.matches ? '--zsag-cols-d' : '--zsag-cols-m');
      return Math.max(1, parseInt(v, 10) || 2);
    }
    bind() {
      const sel = this.querySelector('[data-tri-select]');
      if (sel) sel.addEventListener('change', () => { this.state.tri = sel.value; this.render(); });
      const ph = this.querySelector('[data-filtre-photos]');
      if (ph) ph.addEventListener('click', () => { this.state.photos = !this.state.photos; this.state.vus = this.pas(); this.render(); });
      this.querySelectorAll('[data-etoile]').forEach((b) => b.addEventListener('click', () => {
        const k = parseInt(b.dataset.etoile, 10);
        this.state.etoile = this.state.etoile === k ? 0 : k;
        this.state.vus = this.pas();
        this.render();
        this.grille.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }));
      const raz = this.querySelector('[data-raz]');
      if (raz) raz.addEventListener('click', () => { this.state.photos = false; this.state.etoile = 0; this.state.vus = this.pas(); this.render(); });
      const plus = this.querySelector('[data-plus]');
      if (plus) plus.addEventListener('click', () => { this.state.vus += this.pas(); this.render(); });
      this.querySelectorAll('[data-ouvrir]').forEach((t) => t.addEventListener('click', () => {
        const c = this.querySelector('#' + t.dataset.ouvrir);
        if (c) this.ouvrir(c);
      }));
      this.cards.forEach((c) => c.addEventListener('click', (e) => {
        if (this.dataset.lightbox !== 'true') return;
        if (e.target.closest('a')) return;
        this.ouvrir(c);
      }));
    }
    trier(list) {
      const t = this.state.tri;
      const n = (c, k) => parseFloat(c.dataset[k]) || 0;
      return list.sort((a, b) => {
        const p = n(b, 'pin') - n(a, 'pin');
        if (p) return p;
        let r = 0;
        if (t === 'photos') r = n(b, 'photo') - n(a, 'photo');
        else if (t === 'recent') r = n(b, 'date') - n(a, 'date');
        else if (t === 'haut') r = n(b, 'note') - n(a, 'note') || n(b, 'photo') - n(a, 'photo');
        else if (t === 'bas') r = n(a, 'note') - n(b, 'note');
        else if (t === 'utile') r = n(b, 'utile') - n(a, 'utile');
        return r || n(a, 'i') - n(b, 'i');
      });
    }
    render(soft) {
      const s = this.state;
      let list = this.cards.filter((c) => {
        if (s.photos && c.dataset.photo !== '1') return false;
        if (s.etoile && Math.round(parseFloat(c.dataset.note)) !== s.etoile) return false;
        return true;
      });
      list = this.trier(list);
      const vis = list.slice(0, s.vus);
      const nb = this.cols();
      this._cols = nb;
      if (soft && this._lastVis && this._lastVis.length === vis.length && this._lastVis.every((c, i) => c === vis[i]) && this._lastCols === nb) {
        this.placer(vis, nb);
        return;
      }
      this._lastVis = vis;
      this._lastCols = nb;
      this.placer(vis, nb);
      const plus = this.querySelector('[data-plus]');
      if (plus) plus.hidden = list.length <= vis.length;
      const aucun = this.querySelector('[data-aucun]');
      if (aucun) aucun.hidden = list.length > 0;
      const raz = this.querySelector('[data-raz]');
      if (raz) raz.hidden = !(s.photos || s.etoile);
      const ph = this.querySelector('[data-filtre-photos]');
      if (ph) ph.setAttribute('aria-pressed', s.photos ? 'true' : 'false');
      this.querySelectorAll('[data-etoile]').forEach((b) => b.setAttribute('aria-pressed', parseInt(b.dataset.etoile, 10) === s.etoile ? 'true' : 'false'));
      requestAnimationFrame(() => this.suites());
    }
    placer(vis, nb) {
      this.cards.forEach((c) => this.holder.appendChild(c));
      this.grille.innerHTML = '';
      this.grille.classList.add('is-masonry');
      const cols = [];
      const h = [];
      for (let i = 0; i < nb; i++) {
        const col = document.createElement('div');
        col.className = 'zsag-col';
        this.grille.appendChild(col);
        cols.push(col);
        h.push(0);
      }
      vis.forEach((c) => {
        let k = 0;
        for (let i = 1; i < nb; i++) if (h[i] < h[k] - 1) k = i;
        cols[k].appendChild(c);
        h[k] = cols[k].offsetHeight;
      });
      this.grille.appendChild(this.holder);
    }
    suites() {
      if (this.dataset.lightbox !== 'true') return;
      this.cards.forEach((c) => {
        const t = c.querySelector('.zsag-card__texte');
        const b = c.querySelector('.zsag-card__suite');
        if (!b) return;
        b.hidden = !(t && t.scrollHeight > t.clientHeight + 2);
      });
    }
    ouvrir(card) {
      if (!this.dlg) return;
      const tpl = card.querySelector('template.zsag-full');
      if (!tpl) return;
      const box = this.dlg.querySelector('[data-contenu]');
      box.innerHTML = '';
      box.appendChild(tpl.content.cloneNode(true));
      this.dlg.classList.toggle('is-photo', card.dataset.photo === '1');
      const piste = box.querySelector('.zsag-full__piste');
      const go = (dir) => { if (piste) piste.scrollBy({ left: dir * piste.clientWidth, behavior: 'smooth' }); };
      const prev = box.querySelector('[data-prev]');
      const next = box.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => go(-1));
      if (next) next.addEventListener('click', () => go(1));
      this._retour = document.activeElement;
      this.dlg.showModal();
      document.documentElement.style.overflow = 'hidden';
    }
    bindDialogs() {
      [this.querySelector('.zsag-dlg--avis'), this.querySelector('.zsag-dlg--form')].forEach((d) => {
        if (!d || d._zsag) return;
        d._zsag = true;
        d.querySelectorAll('[data-fermer]').forEach((b) => b.addEventListener('click', () => d.close()));
        d.addEventListener('click', (e) => { if (e.target === d) d.close(); });
        d.addEventListener('close', () => {
          d.querySelectorAll('video').forEach((v) => v.pause());
          document.documentElement.style.overflow = '';
          if (this._retour && this._retour.focus) this._retour.focus();
        });
      });
      this.querySelectorAll('[data-ecrire]').forEach((b) => b.addEventListener('click', () => {
        if (!this.dlgForm) return;
        this._retour = b;
        this.dlgForm.showModal();
        document.documentElement.style.overflow = 'hidden';
      }));
      if (this.dlgForm && this.dlgForm.querySelector('[data-rouvrir]') && !this.dlgForm.open) {
        this.dlgForm.showModal();
      }
    }
  }
  customElements.define('zs-avis-grille', ZsAvisGrille);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-benefices-camera"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || customElements.get('zs-benefices-camera')) return;

    class ZsBeneficesCamera extends HTMLElement {
      connectedCallback() {
        this.nettoyer();

        // Disposition « autour » (mobile) : pictos posés sur le contour pointillé
        if (this.querySelector('.zsbc__contour')) this.suivreContour();

        const reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.anim === 'aucune' || reduit || !('IntersectionObserver' in window)) return;

        const cibles = this.querySelectorAll('[data-zsbc-reveal]');
        if (!cibles.length) return;
        const rejouer = this.dataset.rejouer === 'true';

        // Masque les éléments seulement quand le script tourne : sans lui, tout reste visible
        this.classList.add('is-arme');

        this.observateur = new IntersectionObserver(
          (entrees) => {
            entrees.forEach((entree) => {
              if (entree.isIntersecting) {
                entree.target.classList.add('is-visible');
                if (!rejouer) this.observateur.unobserve(entree.target);
              } else if (rejouer && entree.boundingClientRect.top > 0) {
                // Repassé sous l'écran : l'animation rejouera à la prochaine descente
                entree.target.classList.remove('is-visible');
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
        );

        cibles.forEach((cible) => this.observateur.observe(cible));
      }

      disconnectedCallback() {
        this.nettoyer();
      }

      nettoyer() {
        if (this.observateur) this.observateur.disconnect();
        if (this.observateurTaille) this.observateurTaille.disconnect();
        if (this.surRedimension) window.removeEventListener('resize', this.surRedimension);
        clearTimeout(this.minuteur);
      }

      suivreContour() {
        const placer = () => this.placerSurContour();
        const differer = () => {
          clearTimeout(this.minuteur);
          this.minuteur = setTimeout(placer, 80);
        };
        placer();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(placer);
        this.surRedimension = differer;
        window.addEventListener('resize', differer);
        if ('ResizeObserver' in window) {
          this.observateurTaille = new ResizeObserver(differer);
          this.observateurTaille.observe(this);
        }
      }

      // Chaque picto descend (rangée du haut) ou monte (rangée du bas) jusqu'au contour, qui s'arrondit
      // aux coins : les pictos des côtés se posent plus bas que celui du centre, comme sur un anneau.
      placerSurContour() {
        const items = this.querySelectorAll('.zsbc__item');
        const contour = this.querySelector('.zsbc__contour');
        const rect = contour && contour.querySelector('rect');
        if (!rect || getComputedStyle(contour).display === 'none') {
          items.forEach((item) => {
            item.style.removeProperty('--zsbc-decalage');
            item.style.removeProperty('--zsbc-decalage-x');
          });
          return;
        }

        // Un nombre entier de points sur le tour : pas de trou à la jonction
        const longueur = rect.getTotalLength ? rect.getTotalLength() : 0;
        const pas = parseFloat(getComputedStyle(this).getPropertyValue('--zsbc-contour-espace')) || 14;
        if (longueur > 0) {
          const nombre = Math.max(8, Math.round(longueur / pas));
          rect.style.strokeDasharray = '0.001 ' + (longueur / nombre - 0.001);
        }

        // Boîte du contour mesurée sur l'image (le contour lui-même bouge pendant l'animation)
        const media = this.querySelector('.zsbc__media').getBoundingClientRect();
        if (!media.width) return;
        const ecart = parseFloat(getComputedStyle(this).getPropertyValue('--zsbc-contour-ecart')) || 0;
        const boite = {
          left: media.left - ecart,
          top: media.top - ecart,
          bottom: media.bottom + ecart,
          width: media.width + 2 * ecart
        };
        const rx = rect.rx.baseVal.value;
        const ry = rect.ry.baseVal.value;
        const centre = boite.left + boite.width / 2;
        const demi = boite.width / 2;
        const droit = Math.max(demi - rx, 0);

        items.forEach((item) => {
          const picto = item.querySelector('.zsbc__picto');
          if (!picto) return;
          item.style.setProperty('--zsbc-decalage', '0px');
          item.style.setProperty('--zsbc-decalage-x', '0px');
          const p = picto.getBoundingClientRect();
          const px = p.left + p.width / 2;
          const ecartCentre = px - centre;
          // Un picto plus large que le contour est ramené sur son bord
          const x = Math.min(Math.abs(ecartCentre), demi);
          let y = 0;
          if (x > droit && rx > 0) {
            const u = Math.min((x - droit) / rx, 1);
            y = ry * (1 - Math.sqrt(1 - u * u));
          }
          const enHaut = item.classList.contains('zsbc__item--gauche');
          const cibleY = enHaut ? boite.top + y : boite.bottom - y;
          const cibleX = centre + Math.sign(ecartCentre) * x;
          item.style.setProperty('--zsbc-decalage', (cibleY - (p.top + p.height / 2)).toFixed(1) + 'px');
          item.style.setProperty('--zsbc-decalage-x', (cibleX - px).toFixed(1) + 'px');
        });
      }

      toutAfficher() {
        this.querySelectorAll('[data-zsbc-reveal]').forEach((cible) => cible.classList.add('is-visible'));
      }
    }

    customElements.define('zs-benefices-camera', ZsBeneficesCamera);

    // Éditeur de thème : un bloc sélectionné apparaît tout de suite
    document.addEventListener('shopify:block:select', (event) => {
      const racine = event.target && event.target.closest ? event.target.closest('zs-benefices-camera') : null;
      if (racine && racine.toutAfficher) racine.toutAfficher();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || customElements.get('zs-collection')) return;

    function mouvementReduit() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /** Retire les paramètres techniques (section_id, page) d'une adresse. */
    function nettoyer(url) {
      var u = new URL(url, window.location.href);
      u.searchParams.delete('section_id');
      u.searchParams.delete('page');
      return u;
    }

    function clicSimple(e) {
      return !(e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey);
    }

    class ZsCollection extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.recherche = window.location.search;
        this._clic = this.clic.bind(this);
        this._change = this.change.bind(this);
        this._envoi = this.envoi.bind(this);
        this._pop = this.pop.bind(this);
        this._ferme = this.apresFermeture.bind(this);
        this.addEventListener('click', this._clic);
        this.addEventListener('change', this._change);
        this.addEventListener('submit', this._envoi);
        window.addEventListener('popstate', this._pop);
        var tiroir = this.tiroir;
        if (tiroir) tiroir.addEventListener('close', this._ferme);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._clic);
        this.removeEventListener('change', this._change);
        this.removeEventListener('submit', this._envoi);
        window.removeEventListener('popstate', this._pop);
        clearTimeout(this.minuteur);
        if (this.ctrl) this.ctrl.abort();
        this.deverrouiller();
      }

      get tiroir() {
        return this.querySelector('[data-zscol-tiroir]');
      }

      /* ---------- Événements ---------- */

      clic(e) {
        var t = e.target;
        if (!(t instanceof Element)) return;

        var tiroir = this.tiroir;
        if (tiroir && t === tiroir) {
          this.fermer();
          return;
        }

        /* Carte produit : navigation normale vers la fiche (effet d'appui géré par snippets/zs-carte-produit.liquid). */
        if (t.closest('.zs-carte')) return;

        var pastille = t.closest('[data-zscol-pastille]');
        if (pastille && clicSimple(e)) {
          e.preventDefault();
          this.aller(this.urlPastille(pastille));
          return;
        }

        var tout = t.closest('[data-zscol-tout]');
        if (tout && clicSimple(e)) {
          e.preventDefault();
          this.aller(this.urlTout());
          return;
        }

        var lien = t.closest('a[data-zscol-lien]');
        if (lien && clicSimple(e)) {
          e.preventDefault();
          var depuisTiroir = !!lien.closest('[data-zscol-tiroir]');
          this.aller(lien.href, { remonter: !depuisTiroir });
          return;
        }

        if (t.closest('[data-zscol-ouvrir]')) {
          e.preventDefault();
          this.ouvrir();
          return;
        }

        if (t.closest('[data-zscol-fermer]')) {
          e.preventDefault();
          this.fermer();
          return;
        }

        var plus = t.closest('a[data-zscol-plus]');
        if (plus && clicSimple(e)) {
          e.preventDefault();
          this.voirPlus(plus);
        }
      }

      change(e) {
        var t = e.target;
        if (!(t instanceof Element)) return;

        if (t.matches('[data-zscol-tri]')) {
          this.aller(this.urlTri(t.value), { remonter: true });
          return;
        }

        var form = t.closest('[data-zscol-form]');
        if (form) {
          var self = this;
          clearTimeout(this.minuteur);
          this.minuteur = setTimeout(
            function () {
              self.aller(self.urlFormulaire(form));
            },
            t.type === 'number' ? 0 : 300
          );
        }
      }

      envoi(e) {
        var form = e.target instanceof Element ? e.target.closest('[data-zscol-form]') : null;
        if (!form) return;
        e.preventDefault();
        clearTimeout(this.minuteur);
        this.aller(this.urlFormulaire(form), { fermer: true, remonter: true });
      }

      pop() {
        if (window.location.search === this.recherche) return;
        this.recherche = window.location.search;
        this.rendre(window.location.href, {});
      }

      /* ---------- Adresses ---------- */

      pastilles() {
        return Array.prototype.map.call(this.querySelectorAll('[data-zscol-pastille]'), function (p) {
          var valeurs = [];
          try {
            valeurs = JSON.parse(p.getAttribute('data-valeurs') || '[]');
          } catch (err) {}
          return { param: p.getAttribute('data-param'), valeurs: valeurs };
        });
      }

      remplacer(u, param, valeurs) {
        u.searchParams.delete(param);
        valeurs.forEach(function (v) {
          u.searchParams.append(param, v);
        });
      }

      urlPastille(pastille) {
        var u = nettoyer(window.location.href);
        var param = pastille.getAttribute('data-param');
        var valeurs = [];
        try {
          valeurs = JSON.parse(pastille.getAttribute('data-valeurs') || '[]');
        } catch (err) {}
        var actuelles = u.searchParams.getAll(param);
        var active = valeurs.some(function (v) {
          return actuelles.indexOf(v) !== -1;
        });
        var self = this;

        if (this.dataset.pastilles === 'multiple') {
          var reste = active
            ? actuelles.filter(function (v) {
                return valeurs.indexOf(v) === -1;
              })
            : actuelles.concat(
                valeurs.filter(function (v) {
                  return actuelles.indexOf(v) === -1;
                })
              );
          this.remplacer(u, param, reste);
        } else {
          /* Une seule pastille à la fois : on retire les valeurs des autres pastilles, puis on bascule celle-ci. */
          this.pastilles().forEach(function (p) {
            if (!p.param || p.param === param) return;
            self.remplacer(
              u,
              p.param,
              u.searchParams.getAll(p.param).filter(function (v) {
                return p.valeurs.indexOf(v) === -1;
              })
            );
          });
          this.remplacer(u, param, active ? [] : valeurs);
        }
        return u.toString();
      }

      urlTout() {
        var u = nettoyer(window.location.href);
        var self = this;
        this.pastilles().forEach(function (p) {
          if (!p.param) return;
          self.remplacer(
            u,
            p.param,
            u.searchParams.getAll(p.param).filter(function (v) {
              return p.valeurs.indexOf(v) === -1;
            })
          );
        });
        return u.toString();
      }

      urlTri(valeur) {
        var u = nettoyer(window.location.href);
        u.searchParams.set('sort_by', valeur);
        return u.toString();
      }

      urlFormulaire(form) {
        var u = nettoyer(window.location.href);
        Array.from(u.searchParams.keys()).forEach(function (k) {
          if (k.indexOf('filter.') === 0) u.searchParams.delete(k);
        });
        new FormData(form).forEach(function (v, k) {
          if (k.indexOf('filter.') === 0 && String(v).trim() !== '') u.searchParams.append(k, v);
        });
        return u.toString();
      }

      /* ---------- Rendu ---------- */

      aller(url, opts) {
        opts = opts || {};
        var cible = nettoyer(url).toString();
        if (cible === window.location.href) {
          if (opts.fermer) this.fermer();
          return;
        }
        window.history.pushState({ zscol: this.sectionId }, '', cible);
        this.recherche = window.location.search;
        this.rendre(cible, opts);
      }

      async rendre(url, opts) {
        opts = opts || {};
        if (this.ctrl) this.ctrl.abort();
        var ctrl = (this.ctrl = new AbortController());
        var adresse = new URL(url, window.location.href);
        adresse.searchParams.set('section_id', this.sectionId);
        this.classList.add('zscol--charge');

        var doc;
        try {
          var rep = await fetch(adresse.toString(), { signal: ctrl.signal });
          if (!rep.ok) throw new Error(String(rep.status));
          doc = new DOMParser().parseFromString(await rep.text(), 'text/html');
        } catch (err) {
          if (err && err.name === 'AbortError') return;
          window.location.href = url;
          return;
        }
        if (ctrl !== this.ctrl) return;

        var neuf = doc.querySelector('zs-collection');
        if (!neuf) {
          window.location.href = url;
          return;
        }

        this.remplacerZones(neuf);
        this.classList.remove('zscol--charge');
        this.annoncer();
        if (opts.fermer) this.fermer();
        if (opts.remonter) this.remonter();
        this.dispatchEvent(new CustomEvent('zscol:maj', { bubbles: true }));
      }

      remplacerZones(neuf) {
        var actif = document.activeElement;
        var actifId = actif && this.contains(actif) && actif.id ? actif.id : null;
        var corps = this.querySelector('[data-zscol-tiroir-corps]');
        var defil = corps ? corps.scrollTop : 0;
        var pastilles = this.querySelector('[data-zscol-zone="pastilles"]');
        var defilPastilles = pastilles ? pastilles.scrollLeft : 0;
        var ouverts = {};
        this.querySelectorAll('[data-zscol-groupe]').forEach(function (g) {
          ouverts[g.getAttribute('data-zscol-groupe')] = g.open;
        });

        this.querySelectorAll('[data-zscol-zone]').forEach(function (zone) {
          var nom = zone.getAttribute('data-zscol-zone');
          var remplacant = neuf.querySelector('[data-zscol-zone="' + nom + '"]');
          if (remplacant) zone.replaceWith(document.importNode(remplacant, true));
        });

        this.querySelectorAll('[data-zscol-groupe]').forEach(function (g) {
          var cle = g.getAttribute('data-zscol-groupe');
          if (Object.prototype.hasOwnProperty.call(ouverts, cle)) g.open = ouverts[cle];
        });
        this.nettoyerLiens();
        var corps2 = this.querySelector('[data-zscol-tiroir-corps]');
        if (corps2) corps2.scrollTop = defil;
        var pastilles2 = this.querySelector('[data-zscol-zone="pastilles"]');
        if (pastilles2) pastilles2.scrollLeft = defilPastilles;
        if (actifId) {
          var el = document.getElementById(actifId);
          if (el && this.contains(el)) el.focus({ preventScroll: true });
        }
      }

      /* Les liens renvoyés par la Section Rendering API peuvent contenir section_id : on le retire. */
      nettoyerLiens() {
        this.querySelectorAll('a[href*="section_id"]').forEach(function (a) {
          var u = new URL(a.getAttribute('href'), window.location.href);
          u.searchParams.delete('section_id');
          a.setAttribute('href', u.pathname + u.search + u.hash);
        });
      }

      annoncer() {
        var annonce = this.querySelector('[data-zscol-annonce]');
        var compte = this.querySelector('[data-zscol-zone="compte"]');
        if (!annonce || !compte) return;
        var texte = compte.getAttribute('data-texte') || compte.textContent.trim();
        annonce.textContent = '';
        setTimeout(function () {
          annonce.textContent = texte;
        }, 60);
      }

      remonter() {
        var resultats = this.querySelector('[data-zscol-resultats]');
        if (!resultats) return;
        var barre = this.querySelector('.zscol__barre');
        var bas = barre ? barre.getBoundingClientRect().bottom : 0;
        if (resultats.getBoundingClientRect().top < Math.max(bas, 0) - 1) {
          resultats.scrollIntoView({ block: 'start', behavior: mouvementReduit() ? 'auto' : 'smooth' });
        }
      }

      async voirPlus(lien) {
        if (this.chargePlus) return;
        this.chargePlus = true;
        lien.setAttribute('aria-busy', 'true');
        var adresse = new URL(lien.href, window.location.href);
        adresse.searchParams.set('section_id', this.sectionId);
        try {
          var rep = await fetch(adresse.toString());
          if (!rep.ok) throw new Error(String(rep.status));
          var doc = new DOMParser().parseFromString(await rep.text(), 'text/html');
          var neuf = doc.querySelector('zs-collection');
          var grille = this.querySelector('[data-zscol-grille]');
          var items = neuf ? neuf.querySelectorAll('[data-zscol-grille] > [data-zscol-item]') : [];
          if (!grille || !items.length) throw new Error('vide');
          var premier = null;
          items.forEach(function (li) {
            var n = document.importNode(li, true);
            if (!premier) premier = n;
            grille.appendChild(n);
          });
          var zone = this.querySelector('[data-zscol-zone="plus"]');
          var zoneNeuve = neuf.querySelector('[data-zscol-zone="plus"]');
          if (zone && zoneNeuve) zone.replaceWith(document.importNode(zoneNeuve, true));
          this.nettoyerLiens();
          var lienCarte = premier ? premier.querySelector('.zs-carte__lien') : null;
          if (lienCarte) lienCarte.focus({ preventScroll: true });
        } catch (err) {
          var repli = new URL(lien.href, window.location.href);
          repli.searchParams.delete('section_id');
          window.location.href = repli.toString();
        } finally {
          this.chargePlus = false;
          lien.removeAttribute('aria-busy');
        }
      }

      /* ---------- Panneau de filtres ---------- */

      ouvrir() {
        var tiroir = this.tiroir;
        if (!tiroir || tiroir.open) return;
        this.retour = document.activeElement;
        tiroir.classList.remove('is-fermeture');
        if (typeof tiroir.showModal === 'function') tiroir.showModal();
        else tiroir.setAttribute('open', '');
        document.documentElement.setAttribute('scroll-lock', '');
        this.verrou = true;
      }

      fermer() {
        var tiroir = this.tiroir;
        var self = this;
        if (!tiroir || !tiroir.open || tiroir.classList.contains('is-fermeture')) return;
        var finir = function () {
          tiroir.classList.remove('is-fermeture');
          if (tiroir.open) tiroir.close();
          self.apresFermeture();
        };
        if (mouvementReduit()) {
          finir();
          return;
        }
        tiroir.classList.add('is-fermeture');
        setTimeout(finir, 190);
      }

      /* Appelée après fermeture par le bouton, par Échap (événement close) ou après validation. */
      apresFermeture() {
        this.deverrouiller();
        var actif = document.activeElement;
        var tiroir = this.tiroir;
        if (actif && actif !== document.body && !(tiroir && tiroir.contains(actif))) return;
        var retour = this.retour;
        var valable = retour && retour !== document.body && document.contains(retour) && this.contains(retour);
        var cible = valable ? retour : this.querySelector('[data-zscol-ouvrir]');
        if (cible) cible.focus({ preventScroll: true });
      }

      deverrouiller() {
        if (!this.verrou) return;
        document.documentElement.removeAttribute('scroll-lock');
        this.verrou = false;
      }
    }

    customElements.define('zs-collection', ZsCollection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-hero-homepage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || customElements.get('zshe-bandeau')) return;

    const deux = (n) => String(n).padStart(2, '0');

    // Bandeau caméra : date du jour, heure qui avance ou heure réelle du visiteur
    class ZsheBandeau extends HTMLElement {
      connectedCallback() {
        this.elDate = this.dataset.date === 'jour' ? this.querySelector('[data-zshe-date]') : null;
        this.elHeure = this.querySelector('[data-zshe-heure]');
        this.modeHeure = this.dataset.heure || 'fixe';
        this.sep = this.dataset.dateSep || '-';
        this.depart = Date.now();
        this.base = null;

        if (this.modeHeure === 'defile' && this.elHeure) {
          const m = this.elHeure.textContent.trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
          if (m) this.base = (+m[1] * 3600) + (+m[2] * 60) + (+(m[3] || 0));
          else this.modeHeure = 'fixe';
        }
        if (!this.elHeure) this.modeHeure = 'fixe';

        this.maj();
        if (this.modeHeure !== 'fixe' || this.elDate) {
          this.timer = setInterval(() => this.maj(), 1000);
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      maj() {
        const now = new Date();
        if (this.elDate) {
          this.elDate.textContent = deux(now.getDate()) + this.sep + deux(now.getMonth() + 1) + this.sep + now.getFullYear();
        }
        if (this.modeHeure === 'reelle') {
          this.elHeure.textContent = deux(now.getHours()) + ':' + deux(now.getMinutes()) + ':' + deux(now.getSeconds());
        } else if (this.modeHeure === 'defile') {
          const t = (this.base + Math.floor((Date.now() - this.depart) / 1000)) % 86400;
          this.elHeure.textContent = deux(Math.floor(t / 3600)) + ':' + deux(Math.floor((t % 3600) / 60)) + ':' + deux(t % 60);
        }
      }
    }

    customElements.define('zshe-bandeau', ZsheBandeau);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-hero-pro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zshp-hero')) {
    class ZshpHero extends HTMLElement {
      connectedCallback() {
        this.calme = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 989px)');
        this.surMedia = () => this.chargerVideos();
        this.mobile.addEventListener('change', this.surMedia);
        this.calme.addEventListener('change', this.surMedia);
        this.chargerVideos();
      }

      disconnectedCallback() {
        this.mobile.removeEventListener('change', this.surMedia);
        this.calme.removeEventListener('change', this.surMedia);
      }

      chargerVideos() {
        const estMobile = this.mobile.matches;
        this.querySelectorAll('.zshp__video').forEach((video) => {
          const conteneur = video.closest('.zshp__m');
          const visible =
            conteneur.classList.contains('zshp__m--tous') ||
            (estMobile ? conteneur.classList.contains('zshp__m--mobile') : conteneur.classList.contains('zshp__m--ordi'));

          if (!visible || this.calme.matches) {
            video.pause();
            return;
          }
          if (!video.dataset.charge) {
            video.dataset.charge = '1';
            const source = video.dataset.src;
            const hauteur = Number(estMobile ? this.dataset.renduM : this.dataset.rendu) || 1080;
            const choisir = window.zsVideoRendu ? window.zsVideoRendu(source, hauteur) : Promise.resolve(source);
            choisir.then((url) => {
              video.src = url || source;
              const pret = () => video.classList.add('is-pret');
              video.addEventListener('playing', pret, { once: true });
              video.addEventListener('loadeddata', pret, { once: true });
              video.play().catch(() => {});
            });
          } else {
            video.play().catch(() => {});
          }
        });
      }
    }
    customElements.define('zshp-hero', ZshpHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-pictos-texte"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || customElements.get('zs-pictos-texte')) return;

    class ZsPictosTexte extends HTMLElement {
      connectedCallback() {
        if (this.observateur) this.observateur.disconnect();
        const reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.anim === 'aucune' || reduit || !('IntersectionObserver' in window)) return;

        // Masque les éléments seulement quand le script tourne : sans lui, tout reste visible
        this.classList.add('is-arme');

        this.observateur = new IntersectionObserver(
          (entrees) => {
            entrees.forEach((entree) => {
              if (!entree.isIntersecting) return;
              this.classList.add('is-visible');
              this.observateur.disconnect();
            });
          },
          { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
        );
        this.observateur.observe(this);
      }

      disconnectedCallback() {
        if (this.observateur) this.observateur.disconnect();
      }
    }

    customElements.define('zs-pictos-texte', ZsPictosTexte);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-pourquoi"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('zs-pourquoi')) return;

    class ZsPourquoi extends HTMLElement {
      connectedCallback() {
        if (!this.classList.contains('zspq--apparition')) return;
        const cartes = [...this.querySelectorAll('.zspq__carte')];
        const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduit || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
          cartes.forEach((c) => c.classList.add('is-visible'));
          return;
        }
        this.observateur = new IntersectionObserver((entrees) => {
          entrees.forEach((e) => {
            if (!e.isIntersecting) return;
            const i = cartes.indexOf(e.target);
            setTimeout(() => e.target.classList.add('is-visible'), Math.max(i, 0) * 90);
            this.observateur.unobserve(e.target);
          });
        }, { threshold: 0.15 });
        cartes.forEach((c) => this.observateur.observe(c));
      }

      disconnectedCallback() {
        if (this.observateur) this.observateur.disconnect();
      }
    }

    customElements.define('zs-pourquoi', ZsPourquoi);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zsq-quiz')) {
    const USAGES = ['chasse', 'faune', 'propriete'];
    const QUESTIONS = ['usage', 'crainte', 'tel', 'reseau', 'soleil', 'budgetsd', 'budget4g'];

    class ZsqQuiz extends HTMLElement {
      connectedCallback() {
        this.cleStockage = 'zsq-' + this.dataset.section;
        this.etapes = {};
        this.querySelectorAll('[data-etape]').forEach((el) => { this.etapes[el.dataset.etape] = el; });
        this.retour = this.querySelector('[data-zsq-retour]');
        this.compteur = this.querySelector('[data-zsq-compteur]');
        this.barre = this.querySelector('[data-zsq-barre]');
        this.form = document.getElementById('zsq-form-' + this.dataset.section);
        this.champ = this.querySelector('.zsq__email-champ');
        this.erreur = this.querySelector('[data-zsq-email-erreur]');
        this.reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.reponses = {};
        this.usageFixe = false;
        this.sansEmail = false;
        this.pas = 0;

        this.addEventListener('click', (e) => {
          const choix = e.target.closest('.zsq__choix');
          if (choix && this.contains(choix)) this.choisir(choix);
          if (e.target.closest('[data-zsq-retour]')) this.precedent();
          if (e.target.closest('[data-zsq-recommencer]')) this.recommencer();
          if (e.target.closest('[data-zsq-passer]')) this.passer();
          if (e.target.closest('[data-zsq-vers-email]')) this.versEmail();
        });
        if (this.form) this.form.addEventListener('submit', (e) => this.envoyer(e));
        if (this.champ) this.champ.addEventListener('input', () => this.montrerErreur(false));
        this.surPopstate = (e) => {
          const st = e.state;
          if (st && st.zsq === this.dataset.section && typeof st.pas === 'number') this.aller(st.pas, false);
          else if (!this.fini) this.aller(0, false);
        };
        window.addEventListener('popstate', this.surPopstate);

        this.demarrer();
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this.surPopstate);
        this.arreterMinuteurs();
      }

      lire() {
        try { return JSON.parse(sessionStorage.getItem(this.cleStockage) || 'null'); } catch (e) { return null; }
      }
      ecrire(v) {
        try {
          if (v) sessionStorage.setItem(this.cleStockage, JSON.stringify(v));
          else sessionStorage.removeItem(this.cleStockage);
        } catch (e) {}
      }

      demarrer() {
        if (this.dataset.editeur === 'true' && this.dataset.apercu !== 'quiz') {
          this.reponses = { usage: 'chasse', crainte: 'rater', tel: '4g', reseau: 'oui', soleil: 'soleil', budget: '3' };
          if (this.dataset.apercu === 'resultat') this.afficherResultat(this.dataset.apercuCle);
          else this.aller(this.sequence().indexOf(this.dataset.apercu === 'analyse' ? 'analyse' : 'email'), false);
          return;
        }

        const s = this.lire();
        const retourFormulaire = this.dataset.poste === 'true' || this.dataset.erreur === 'true';
        if (this.dataset.editeur !== 'true' && s && s.cle && (retourFormulaire || s.fini)) {
          this.reponses = s.reponses || {};
          this.sansEmail = !retourFormulaire && s.sansEmail === true;
          this.ecrire({ reponses: this.reponses, cle: s.cle, fini: true, sansEmail: this.sansEmail });
          this.afficherResultat(s.cle);
          if (retourFormulaire) requestAnimationFrame(() => this.remonter(true));
          return;
        }

        const usage = new URLSearchParams(location.search).get('usage');
        if (USAGES.includes(usage)) {
          this.reponses.usage = usage;
          this.usageFixe = true;
        }
        this.aller(0, false);
        try { history.replaceState(Object.assign({}, history.state, { zsq: this.dataset.section, pas: 0 }), ''); } catch (e) {}
      }

      /* Ordre des écrans selon les réponses déjà données */
      sequence() {
        const r = this.reponses;
        const s = this.usageFixe ? ['crainte', 'tel'] : ['usage', 'crainte', 'tel'];
        if (r.tel === '4g') s.push('reseau');
        if (this.branche() !== 'wifi') s.push('soleil', r.tel === '4g' ? 'budget4g' : 'budgetsd');
        s.push('analyse', 'email');
        return s;
      }

      branche() {
        const r = this.reponses;
        if (r.tel === 'wifi' || (r.tel === '4g' && r.reseau === 'aucun')) return 'wifi';
        return r.tel === '4g' ? '4g' : 'sd';
      }

      /* Matrice réponses → caméra */
      resultat() {
        const r = this.reponses;
        const soleil = r.soleil === 'soleil';
        const b = r.budget || '2';
        switch (this.branche()) {
          case 'wifi': return 'a400wpro';
          case '4g':
            if (b === '1') return 'g500spro';
            if (b === '2') return soleil ? 'g300s' : 'g400';
            return 'g600dmax';
          default:
            if (b === '1') return 'a150';
            if (b === '2') return soleil ? 'a300s' : 'a400pro';
            return 'a500max';
        }
      }

      profil() {
        const u = this.reponses.usage;
        if (u === 'faune' || u === 'propriete') return u;
        return this.branche() === '4g' ? 'chasse4g' : 'chasse';
      }

      notes() {
        const r = this.reponses;
        const n = [];
        if (r.tel === '4g' && r.reseau === 'faible') n.push('reseau-faible');
        if (r.tel === '4g' && r.reseau === 'inconnu') n.push('reseau-inconnu');
        if (r.tel === '4g' && r.reseau === 'aucun') n.push('sans-reseau');
        return n;
      }

      arreterMinuteurs() {
        clearTimeout(this.minuteur);
        (this.minuteursAnalyse || []).forEach(clearTimeout);
        this.minuteursAnalyse = [];
      }

      choisir(bouton) {
        const el = bouton.closest('[data-etape]');
        const etape = el.dataset.etape;
        if (!QUESTIONS.includes(etape)) return;
        const cle = etape.startsWith('budget') ? 'budget' : etape;
        const ancienne = this.reponses[cle];
        this.reponses[cle] = bouton.dataset.valeur;
        if (etape === 'tel' && ancienne !== bouton.dataset.valeur) {
          delete this.reponses.reseau;
          delete this.reponses.budget;
        }
        if (etape === 'reseau' && ancienne !== bouton.dataset.valeur) delete this.reponses.budget;
        el.querySelectorAll('.zsq__choix').forEach((b) => b.classList.toggle('is-choisi', b === bouton));

        /* Réponse d'expert, puis question suivante */
        const texte = this.dataset.retours !== 'false' ? (bouton.dataset.retour || '').trim() : '';
        let delai = 220;
        if (texte) {
          delai = Math.min(3000, 1400 + texte.length * 18);
          this.montrerExpert(el, bouton, texte, delai);
        }
        clearTimeout(this.minuteur);
        this.minuteur = setTimeout(() => this.suivant(), delai);
      }

      /* La boîte se place juste sous la réponse choisie, pour rester visible sur mobile */
      montrerExpert(el, bouton, texte, duree) {
        const boite = el.querySelector('[data-zsq-expert]');
        if (!boite) return;
        boite.classList.remove('is-visible');
        bouton.after(boite);
        boite.querySelector('[data-zsq-expert-texte]').textContent = texte;
        boite.style.setProperty('--zsq-duree', duree + 'ms');
        void boite.offsetWidth;
        boite.classList.add('is-visible');
        const bas = boite.getBoundingClientRect().bottom;
        if (bas > window.innerHeight) boite.scrollIntoView({ block: 'nearest', behavior: this.reduit ? 'auto' : 'smooth' });
      }

      cacherExperts() {
        this.querySelectorAll('[data-zsq-expert]').forEach((b) => {
          b.classList.remove('is-visible');
          const t = b.querySelector('[data-zsq-expert-texte]');
          if (t) t.textContent = '';
        });
      }

      suivant() {
        const suivant = this.pas + 1;
        const nom = this.sequence()[suivant];
        this.aller(suivant, true);
        /* L'analyse n'entre pas dans l'historique : « Retour » depuis l'e-mail revient à la dernière question */
        if (nom !== 'analyse') {
          try { history.pushState({ zsq: this.dataset.section, pas: suivant }, ''); } catch (e) {}
        }
      }

      precedent() {
        if (this.pas <= 0) return;
        if (history.state && history.state.zsq === this.dataset.section && history.state.pas === this.pas) {
          history.back();
          return;
        }
        let cible = this.pas - 1;
        if (this.sequence()[cible] === 'analyse') cible -= 1;
        this.aller(cible, true);
      }

      aller(pas, remonter) {
        this.arreterMinuteurs();
        this.cacherExperts();
        const seq = this.sequence();
        this.pas = Math.max(0, Math.min(pas, seq.length - 1));
        this.fini = false;
        this.classList.remove('zsq--resultat');
        const nom = seq[this.pas];
        this.montrer(nom);

        const el = this.etapes[nom];
        const cle = nom.startsWith('budget') ? 'budget' : nom;
        el.querySelectorAll('.zsq__choix').forEach((b) => b.classList.toggle('is-choisi', b.dataset.valeur === this.reponses[cle]));

        const nbQuestions = seq.length - 2;
        const total = seq.length;
        this.compteur.textContent = this.pas < nbQuestions ? 'Question ' + (this.pas + 1) + ' sur ' + nbQuestions : '';
        this.barre.style.width = Math.round((this.pas / total) * 100) + '%';
        this.retour.hidden = this.pas === 0 || nom === 'analyse';
        if (remonter) {
          this.remonter(false);
          const titre = el.querySelector('.zsq__question');
          if (titre) titre.focus({ preventScroll: true });
        }
        if (nom === 'analyse') this.analyser();
      }

      /* Écran d'analyse : 3 ou 4 lignes tirées des réponses, cochées une à une */
      lignesAnalyse() {
        const r = this.reponses;
        const d = this.etapes.analyse.dataset;
        const lignes = [];
        const branche = this.branche();
        if (branche !== 'wifi') lignes.push(r.soleil === 'soleil' ? d.lSoleil : d.lCouvert);
        if (branche === '4g') lignes.push(d.lQuatreg);
        else if (branche === 'wifi') lignes.push(r.tel === '4g' ? d.lSansreseau : d.lWifi);
        else lignes.push(d.lSd);
        const crainte = { piles: d.lPiles, rater: d.lRater, nuit: d.lNuit, vol: d.lVol, abonnement: d.lAbonnement, reglage: d.lReglage }[r.crainte];
        if (crainte) lignes.push(crainte);
        if (r.budget && d.lBudget) {
          const etape = this.etapes[r.tel === '4g' ? 'budget4g' : 'budgetsd'];
          const b = etape && etape.querySelector('.zsq__choix[data-valeur="' + r.budget + '"]');
          if (b && b.dataset.libelle) lignes.push(d.lBudget.replace('[budget]', b.dataset.libelle.toLowerCase()));
        }
        return lignes.filter((l) => l && l.trim());
      }

      analyser() {
        const liste = this.etapes.analyse.querySelector('[data-zsq-analyse]');
        const coche = this.etapes.analyse.querySelector('[data-zsq-coche]');
        liste.innerHTML = '';
        const items = this.lignesAnalyse().map((texte) => {
          const li = document.createElement('li');
          const rond = document.createElement('span');
          rond.className = 'zsq__analyse-coche';
          rond.setAttribute('aria-hidden', 'true');
          if (coche) rond.appendChild(coche.content.cloneNode(true));
          const t = document.createElement('span');
          t.textContent = texte;
          li.append(rond, t);
          liste.appendChild(li);
          return li;
        });

        const editeur = this.dataset.editeur === 'true';
        const pasLigne = this.reduit ? 0 : 650;
        this.minuteursAnalyse = [];
        items.forEach((li, i) => {
          this.minuteursAnalyse.push(setTimeout(() => li.classList.add('is-encours'), i * pasLigne));
          this.minuteursAnalyse.push(setTimeout(() => {
            li.classList.remove('is-encours');
            li.classList.add('is-fait');
          }, i * pasLigne + (this.reduit ? 0 : 500)));
        });
        if (editeur) return;
        const fin = items.length * pasLigne + (this.reduit ? 1400 : 700);
        this.minuteursAnalyse.push(setTimeout(() => this.suivant(), fin));
      }

      montrer(nom) {
        Object.entries(this.etapes).forEach(([n, el]) => {
          const actif = n === nom;
          el.hidden = !actif;
          el.classList.toggle('is-entree', actif);
        });
      }

      remonter(toujours) {
        const haut = this.getBoundingClientRect().top;
        if (toujours || haut < 0) {
          window.scrollTo({ top: window.scrollY + haut - 12, behavior: this.reduit ? 'auto' : 'smooth' });
        }
      }

      montrerErreur(oui) {
        if (!this.erreur) return;
        this.erreur.hidden = !oui;
        this.champ.setAttribute('aria-invalid', oui ? 'true' : 'false');
      }

      envoyer(e) {
        const email = (this.champ.value || '').trim();
        this.champ.value = email;
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
          e.preventDefault();
          this.montrerErreur(true);
          this.champ.focus();
          return;
        }
        const cle = this.resultat();
        const article = this.querySelector('.zsq__produit[data-cle="' + cle + '"]');
        const tags = ['quiz-camera', 'quiz-' + (article ? article.dataset.tag : cle)];
        if (this.reponses.usage) tags.push('quiz-usage-' + this.reponses.usage);
        if (this.reponses.crainte) tags.push('quiz-crainte-' + this.reponses.crainte);
        const consentement = this.querySelector('[data-zsq-consentement]');
        if (consentement && consentement.checked) tags.push('newsletter');
        const champTags = this.form.querySelector('[data-zsq-tags]');
        if (champTags) champTags.value = tags.join(', ');

        /* Dans l'éditeur de thème, aucun client n'est créé : on montre directement le résultat */
        this.sansEmail = false;
        if (this.dataset.editeur === 'true') {
          e.preventDefault();
          this.afficherResultat(cle);
          return;
        }
        this.ecrire({ reponses: this.reponses, cle: cle, fini: false });
      }

      /* Résultat sans e-mail : aucun client créé, prix plein (sauf remise gardée dans les réglages) */
      passer() {
        const cle = this.resultat();
        this.sansEmail = true;
        if (this.dataset.editeur !== 'true') this.ecrire({ reponses: this.reponses, cle: cle, fini: true, sansEmail: true });
        this.afficherResultat(cle);
        requestAnimationFrame(() => this.remonter(true));
      }

      /* Depuis le résultat sans e-mail : retour au formulaire pour débloquer la remise */
      versEmail() {
        this.sansEmail = false;
        const pas = this.sequence().indexOf('email');
        this.ecrire({ reponses: this.reponses, cle: this.resultat(), fini: false });
        this.aller(pas, true);
        try { history.pushState({ zsq: this.dataset.section, pas: pas }, ''); } catch (e) {}
        if (this.champ) this.champ.focus({ preventScroll: true });
      }

      /* Puces : la crainte d'abord, puis l'emplacement, puis la connexion */
      ordonnerPuces(article) {
        const liste = article.querySelector('[data-zsq-puces]');
        if (!liste) return;
        const lis = Array.from(liste.querySelectorAll('[data-puce]'));
        const existe = (t) => lis.some((li) => li.dataset.puce === t);
        const r = this.reponses;
        let emplacement = r.soleil === 'soleil' ? 'soleil' : 'couvert';
        if (!existe(emplacement)) emplacement = emplacement === 'soleil' ? 'couvert' : 'soleil';
        const ordre = [r.crainte, emplacement, 'connexion'].filter((t, i, a) => t && existe(t) && a.indexOf(t) === i);
        lis.forEach((li) => { li.hidden = !ordre.includes(li.dataset.puce); });
        ordre.forEach((t) => liste.appendChild(lis.find((li) => li.dataset.puce === t)));
      }

      afficherResultat(cle) {
        this.arreterMinuteurs();
        this.fini = true;
        this.classList.add('zsq--resultat');
        /* Prix plein seulement si la remise est réservée à l'e-mail (sinon pas de bloc sans remise) */
        this.classList.toggle('zsq--sans-email', this.sansEmail && !!this.querySelector('[data-zsq-sans-remise]'));
        this.montrer('resultat');
        const res = this.etapes.resultat;
        res.querySelectorAll('[data-retour-avec]').forEach((i) => {
          i.value = this.sansEmail ? i.dataset.retourSans : i.dataset.retourAvec;
        });

        const profil = this.profil();
        res.querySelectorAll('[data-profil]').forEach((p) => { p.hidden = p.dataset.profil !== profil; });

        const modeles = res.querySelector('.zsq__notes-modeles');
        res.querySelectorAll('.zsq__produit').forEach((a) => {
          const actif = a.dataset.cle === cle;
          a.hidden = !actif;
          const zone = a.querySelector('[data-zsq-notes]');
          zone.innerHTML = '';
          if (actif) {
            this.ordonnerPuces(a);
            this.notes().forEach((n) => {
              const modele = modeles.querySelector('[data-note="' + n + '"]');
              if (modele && modele.textContent.trim()) zone.appendChild(modele.cloneNode(true));
            });
          }
        });

        const recap = res.querySelector('[data-zsq-recap]');
        recap.innerHTML = '';
        this.sequence().forEach((nom) => {
          if (!QUESTIONS.includes(nom)) return;
          const cleR = nom.startsWith('budget') ? 'budget' : nom;
          const v = this.reponses[cleR];
          if (!v) return;
          const b = this.etapes[nom].querySelector('.zsq__choix[data-valeur="' + v + '"]');
          if (!b || !b.dataset.libelle) return;
          const li = document.createElement('li');
          li.textContent = b.dataset.libelle;
          recap.appendChild(li);
        });

        this.compteur.textContent = 'Votre résultat';
        this.barre.style.width = '100%';
        this.retour.hidden = true;
        const titre = res.querySelector('h2');
        if (titre) titre.focus({ preventScroll: true });
      }

      recommencer() {
        this.ecrire(null);
        const usage = this.usageFixe ? this.reponses.usage : undefined;
        this.reponses = usage ? { usage } : {};
        this.sansEmail = false;
        if (this.champ) this.champ.value = '';
        this.aller(0, true);
        try { history.pushState({ zsq: this.dataset.section, pas: 0 }, ''); } catch (e) {}
      }
    }

    customElements.define('zsq-quiz', ZsqQuiz);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-texte-media-produit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || customElements.get('zstmp-media')) return;

    class ZstmMedia extends HTMLElement {
      connectedCallback() {
        if (this.dataset.zstmpPret) return;
        this.dataset.zstmpPret = '1';

        // Miniature YouTube : passe en haute définition si elle existe
        const poster = this.querySelector('img[data-maxres]');
        if (poster) {
          const monter = () => {
            const hd = new Image();
            hd.onload = () => {
              if (hd.naturalWidth > 320) poster.src = hd.src;
            };
            hd.src = poster.dataset.maxres;
          };
          if (poster.complete && poster.naturalWidth) monter();
          else poster.addEventListener('load', monter, { once: true });
        }

        // YouTube au clic : le lecteur ne se charge qu'au moment de la lecture
        const lecture = this.querySelector('.zstmp__lecture');
        if (lecture && this.dataset.youtube) {
          lecture.addEventListener('click', (event) => {
            event.preventDefault();
            this.lire();
          });
        }

        // Miniature des vidéos MP4 : posée seulement quand la vidéo approche de l'écran (720 px sur mobile),
        // pour ne rien télécharger au chargement de la page
        this.querySelectorAll('video[data-poster]').forEach((v) => {
          const poser = () => {
            if (v.getAttribute('poster')) return;
            const mobile = window.matchMedia('(max-width: 749px)').matches;
            v.poster = (mobile && v.dataset.posterSd) || v.dataset.poster;
          };
          if (!('IntersectionObserver' in window)) return poser();
          const obs = new IntersectionObserver(
            (entrees) => {
              if (entrees.some((entree) => entree.isIntersecting)) {
                poser();
                obs.disconnect();
              }
            },
            { rootMargin: '800px 0px' }
          );
          obs.observe(v);
        });

        // Définition voulue : 480p sur mobile ou en économie de données, sinon 720p (jamais le 1080p).
        // Liquid ne donne que le 1080p : zsVideoRendu (snippet zs-video-rendu) retrouve le bon MP4.
        const liaison = navigator.connection;
        const leger = window.matchMedia('(max-width: 749px)').matches || (liaison && liaison.saveData);
        const rendu = (url) =>
          window.zsVideoRendu ? window.zsVideoRendu(url, leger ? 480 : 720).catch(() => url) : Promise.resolve(url);

        // Vidéo MP4 en lecture automatique : téléchargée seulement près de l'écran, en pause hors écran
        const auto = this.querySelector('video[data-hd]');
        if (auto) {
          let visible = false;
          const jouer = () => {
            const lecture = auto.play();
            if (lecture && lecture.catch) lecture.catch(() => {});
          };
          const lancer = () => {
            visible = true;
            if (auto.getAttribute('src')) return jouer();
            if (auto.dataset.choix) return;
            auto.dataset.choix = '1';
            rendu((leger ? auto.dataset.sd : auto.dataset.hd) || auto.dataset.hd).then((url) => {
              auto.src = url;
              if (visible) jouer();
            });
          };
          if ('IntersectionObserver' in window) {
            new IntersectionObserver(
              (entrees) => {
                entrees.forEach((entree) => {
                  if (entree.isIntersecting) return lancer();
                  visible = false;
                  auto.pause();
                });
              },
              { rootMargin: '200px 0px' }
            ).observe(auto);
          } else {
            lancer();
          }
        }

        // Vidéo MP4 avec commandes : source remplacée par la bonne définition quand la vidéo approche
        // de l'écran (preload none, donc rien n'est téléchargé avant la lecture)
        const video = this.querySelector('video[controls]');
        const source = video && video.querySelector('source[src]');
        if (source) {
          const choisir = () =>
            rendu(source.getAttribute('src')).then((url) => {
              if (url === source.getAttribute('src') || !video.paused || video.currentTime > 0) return;
              source.setAttribute('src', url);
              video.load();
            });
          if ('IntersectionObserver' in window) {
            const obs = new IntersectionObserver(
              (entrees) => {
                if (entrees.some((entree) => entree.isIntersecting)) {
                  obs.disconnect();
                  choisir();
                }
              },
              { rootMargin: '800px 0px' }
            );
            obs.observe(video);
          } else {
            choisir();
          }
        }

        // Vidéo MP4 avec commandes : le bandeau s'efface pendant la lecture
        if (video) {
          video.addEventListener('play', () => this.classList.add('is-lecture'));
          video.addEventListener('pause', () => this.classList.remove('is-lecture'));
          video.addEventListener('ended', () => this.classList.remove('is-lecture'));
        }
      }

      lire() {
        if (this.querySelector('iframe')) return;
        const iframe = document.createElement('iframe');
        iframe.className = 'zstmp__iframe';
        iframe.src =
          'https://www.youtube-nocookie.com/embed/' +
          encodeURIComponent(this.dataset.youtube) +
          '?autoplay=1&rel=0&playsinline=1';
        iframe.title = this.dataset.titre || 'Vidéo YouTube';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        this.appendChild(iframe);
        this.classList.add('is-lecture');
      }
    }

    customElements.define('zstmp-media', ZstmMedia);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-texte-media"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || customElements.get('zstm-media')) return;

    class ZstmMedia extends HTMLElement {
      connectedCallback() {
        if (this.dataset.zstmPret) return;
        this.dataset.zstmPret = '1';

        // Miniature YouTube : passe en haute définition si elle existe
        const poster = this.querySelector('img[data-maxres]');
        if (poster) {
          const monter = () => {
            const hd = new Image();
            hd.onload = () => {
              if (hd.naturalWidth > 320) poster.src = hd.src;
            };
            hd.src = poster.dataset.maxres;
          };
          if (poster.complete && poster.naturalWidth) monter();
          else poster.addEventListener('load', monter, { once: true });
        }

        // YouTube au clic : le lecteur ne se charge qu'au moment de la lecture
        const lecture = this.querySelector('.zstm__lecture');
        if (lecture && this.dataset.youtube) {
          lecture.addEventListener('click', (event) => {
            event.preventDefault();
            this.lire();
          });
        }

        // Miniature des vidéos MP4 : posée seulement quand la vidéo approche de l'écran (720 px sur mobile),
        // pour ne rien télécharger au chargement de la page
        this.querySelectorAll('video[data-poster]').forEach((v) => {
          const poser = () => {
            if (v.getAttribute('poster')) return;
            const mobile = window.matchMedia('(max-width: 749px)').matches;
            v.poster = (mobile && v.dataset.posterSd) || v.dataset.poster;
          };
          if (!('IntersectionObserver' in window)) return poser();
          const obs = new IntersectionObserver(
            (entrees) => {
              if (entrees.some((entree) => entree.isIntersecting)) {
                poser();
                obs.disconnect();
              }
            },
            { rootMargin: '800px 0px' }
          );
          obs.observe(v);
        });

        // Définition voulue : 480p sur mobile ou en économie de données, sinon 720p (jamais le 1080p).
        // Liquid ne donne que le 1080p : zsVideoRendu (snippet zs-video-rendu) retrouve le bon MP4.
        const liaison = navigator.connection;
        const leger = window.matchMedia('(max-width: 749px)').matches || (liaison && liaison.saveData);
        const rendu = (url) =>
          window.zsVideoRendu ? window.zsVideoRendu(url, leger ? 480 : 720).catch(() => url) : Promise.resolve(url);

        // Vidéo MP4 en lecture automatique : téléchargée seulement près de l'écran, en pause hors écran
        const auto = this.querySelector('video[data-hd]');
        if (auto) {
          let visible = false;
          const jouer = () => {
            const lecture = auto.play();
            if (lecture && lecture.catch) lecture.catch(() => {});
          };
          const lancer = () => {
            visible = true;
            if (auto.getAttribute('src')) return jouer();
            if (auto.dataset.choix) return;
            auto.dataset.choix = '1';
            rendu((leger ? auto.dataset.sd : auto.dataset.hd) || auto.dataset.hd).then((url) => {
              auto.src = url;
              if (visible) jouer();
            });
          };
          if ('IntersectionObserver' in window) {
            new IntersectionObserver(
              (entrees) => {
                entrees.forEach((entree) => {
                  if (entree.isIntersecting) return lancer();
                  visible = false;
                  auto.pause();
                });
              },
              { rootMargin: '200px 0px' }
            ).observe(auto);
          } else {
            lancer();
          }
        }

        // Vidéo MP4 avec commandes : source remplacée par la bonne définition quand la vidéo approche
        // de l'écran (preload none, donc rien n'est téléchargé avant la lecture)
        const video = this.querySelector('video[controls]');
        const source = video && video.querySelector('source[src]');
        if (source) {
          const choisir = () =>
            rendu(source.getAttribute('src')).then((url) => {
              if (url === source.getAttribute('src') || !video.paused || video.currentTime > 0) return;
              source.setAttribute('src', url);
              video.load();
            });
          if ('IntersectionObserver' in window) {
            const obs = new IntersectionObserver(
              (entrees) => {
                if (entrees.some((entree) => entree.isIntersecting)) {
                  obs.disconnect();
                  choisir();
                }
              },
              { rootMargin: '800px 0px' }
            );
            obs.observe(video);
          } else {
            choisir();
          }
        }

        // Vidéo MP4 avec commandes : le bandeau s'efface pendant la lecture
        if (video) {
          video.addEventListener('play', () => this.classList.add('is-lecture'));
          video.addEventListener('pause', () => this.classList.remove('is-lecture'));
          video.addEventListener('ended', () => this.classList.remove('is-lecture'));
        }
      }

      lire() {
        if (this.querySelector('iframe')) return;
        const iframe = document.createElement('iframe');
        iframe.className = 'zstm__iframe';
        iframe.src =
          'https://www.youtube-nocookie.com/embed/' +
          encodeURIComponent(this.dataset.youtube) +
          '?autoplay=1&rel=0&playsinline=1';
        iframe.title = this.dataset.titre || 'Vidéo YouTube';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        this.appendChild(iframe);
        this.classList.add('is-lecture');
      }
    }

    customElements.define('zstm-media', ZstmMedia);
  })();

  } catch(e) { console.error(e); }
})();
})();
